module.exports = __webpack_public_path__ + "images/section-card-image-overlay.svg";